import { ExtranetInviteTokenDto } from '@pharmac-extranet/extranet-api'
import { KeycloakLoginOptions, KeycloakLogoutOptions } from 'keycloak-js'
import React from 'react'
import { AuthenticatedUserDto } from './dto'

export type AuthenticationContext = {
  user: AuthenticatedUserDto | undefined
  isPharmacUser: boolean
  isPharmacCustomerService: boolean
  isLoggedIn: boolean
  doLogout: (options?: KeycloakLogoutOptions) => Promise<void>
  doLogin: (options?: KeycloakLoginOptions) => Promise<void>
  doConsumeToken: (token: string) => Promise<ExtranetInviteTokenDto>
  getChangePasswordUrl: (language?: 'fi' | 'en' | 'sv') => Promise<string>
  userHasRole: (role: string) => boolean
  updateToken: () => Promise<boolean> | void
  hasAcceptedTermsAndConditions: boolean
  hasAcceptedPrivacyPolicy: boolean
  hasInitialized: boolean
}

export const AuthenticationContext = React.createContext({} as AuthenticationContext)
